import { FC } from 'react';
import { Typography } from '@wellstone-solutions/web';

import type { ReactNode } from 'react';

interface TitleProps {
  children: ReactNode;
}

const Title: FC<TitleProps> = (props) => {
  const { children, ...rest } = props;

  return (
    <Typography variant="h3" component="h1" sx={styles.heading} {...rest}>
      {children}
    </Typography>
  );
};

const styles = {
  heading: { textAlign: 'center' },
};

export { Title };
